import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionResultEntryForm from '../../../components/forms/CompetitionResultEntryForm';
import { useCompetitionResultEntryById, useUpdateCompetitionResultEntry } from '../../../hooks/useCompetitionResultEntryApi';
import { useNavigate, useParams } from 'react-router-dom';

const CompetitionResultEntryEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useCompetitionResultEntryById(id!);
  const updateCompetitionResultEntry = useUpdateCompetitionResultEntry();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Result Entries', href: '/admin/competitionresultentries' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateCompetitionResultEntry.mutateAsync({ id: id!, data });
      navigate('/admin/competitionresultentries');
    } catch (error) {
      console.error('Error updating CompetitionResultEntry:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionresultentries"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.CompetitionResultEntry.Edit'
    >
      {entityData ? (
        <CompetitionResultEntryForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/competitionresultentries')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default CompetitionResultEntryEdit;
